import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";

//this is to use with many to many relationships, you will need to know the original values and the new ones.
//will only create and delete
var ManyToManyDataHelper =
/*#__PURE__*/
function () {
  function ManyToManyDataHelper() {
    _classCallCheck(this, ManyToManyDataHelper);
  }

  _createClass(ManyToManyDataHelper, [{
    key: "Process",
    value: function () {
      var _Process = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dataClass, orig, changed, idField, primaryIdField, projectField, projectId) {
        var creates, deletes, updates;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (changed == null) changed = [];
                creates = changed.filter(function (x) {
                  return !orig.find(function (y) {
                    return y[primaryIdField] == x;
                  });
                });
                deletes = orig.filter(function (x) {
                  return !changed.find(function (y) {
                    return y == x[primaryIdField];
                  });
                });
                updates = orig.filter(function (x) {
                  return !creates.find(function (y) {
                    return y == x[primaryIdField];
                  }) && !deletes.find(function (y) {
                    return y[primaryIdField] == x[primaryIdField];
                  });
                });
                _context.next = 6;
                return Promise.all(creates.map(function (c) {
                  var temp = {};
                  temp[primaryIdField] = c;
                  temp[projectField] = projectId;
                  return dataClass.Create(temp);
                }));

              case 6:
                _context.next = 8;
                return Promise.all(deletes.map(function (d) {
                  return dataClass.Delete(d[idField]);
                }));

              case 8:
                _context.next = 10;
                return Promise.all(updates.map(function (u) {
                  return dataClass.Update(u);
                }));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function Process(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
        return _Process.apply(this, arguments);
      }

      return Process;
    }()
  }, {
    key: "ProcessWithInactive",
    value: function () {
      var _ProcessWithInactive = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(dataClass, orig, changed, idField, primaryIdField, projectField, projectId) {
        var creates, inactive, updates;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                creates = changed.filter(function (x) {
                  return !orig.find(function (y) {
                    return y[primaryIdField] === x;
                  });
                });
                inactive = orig.filter(function (x) {
                  return changed.find(function (y) {
                    return y === x[primaryIdField];
                  }) === undefined;
                });
                inactive.forEach(function (element) {
                  element.inactive = true;
                });
                updates = orig.filter(function (x) {
                  return !creates.find(function (y) {
                    return y == x[primaryIdField];
                  }) && !inactive.find(function (y) {
                    return y[primaryIdField] == x[primaryIdField];
                  });
                });
                _context2.next = 6;
                return Promise.all(creates.map(function (c) {
                  var temp = {};
                  temp[primaryIdField] = c;
                  temp[projectField] = projectId;
                  return dataClass.Create(temp);
                }));

              case 6:
                _context2.next = 8;
                return Promise.all(inactive.map(function (d) {
                  return dataClass.Update(d);
                }));

              case 8:
                _context2.next = 10;
                return Promise.all(updates.map(function (u) {
                  return dataClass.Update(u);
                }));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function ProcessWithInactive(_x8, _x9, _x10, _x11, _x12, _x13, _x14) {
        return _ProcessWithInactive.apply(this, arguments);
      }

      return ProcessWithInactive;
    }()
  }, {
    key: "ProcessComplicatedObject",
    value: function () {
      var _ProcessComplicatedObject = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(dataClass, orig, changed, idField) {
        var creates, deletes, updates;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                creates = changed.filter(function (x) {
                  return !orig.find(function (y) {
                    return y[idField] == x[idField];
                  });
                });
                deletes = orig.filter(function (x) {
                  return !changed.find(function (y) {
                    return y[idField] == x[idField];
                  });
                });
                updates = orig.filter(function (x) {
                  return !creates.find(function (y) {
                    return y[idField] == x[idField];
                  }) && !deletes.find(function (y) {
                    return y[idField] == x[idField];
                  });
                });
                _context3.next = 5;
                return Promise.all(creates.map(function (c) {
                  return dataClass.Create(c);
                }));

              case 5:
                _context3.next = 7;
                return Promise.all(deletes.map(function (d) {
                  return dataClass.Delete(d[idField]);
                }));

              case 7:
                _context3.next = 9;
                return Promise.all(updates.map(function (u) {
                  return dataClass.Update(u);
                }));

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function ProcessComplicatedObject(_x15, _x16, _x17, _x18) {
        return _ProcessComplicatedObject.apply(this, arguments);
      }

      return ProcessComplicatedObject;
    }()
  }]);

  return ManyToManyDataHelper;
}();

export default new ManyToManyDataHelper();